export const useStyles = () => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontSize: 18,
    fontWeight: 700,
  },
});
